var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717680",
    d: "M1.66675 3.83333L8.47085 8.5962C9.02182 8.98188 9.29731 9.17472 9.59697 9.24942C9.86166 9.3154 10.1385 9.3154 10.4032 9.24942C10.7029 9.17472 10.9783 8.98188 11.5293 8.5962L18.3334 3.83333M5.66675 14.6667H14.3334C15.7335 14.6667 16.4336 14.6667 16.9684 14.3942C17.4388 14.1545 17.8212 13.772 18.0609 13.3016C18.3334 12.7669 18.3334 12.0668 18.3334 10.6667V5.33333C18.3334 3.9332 18.3334 3.23313 18.0609 2.69835C17.8212 2.22795 17.4388 1.8455 16.9684 1.60581C16.4336 1.33333 15.7335 1.33333 14.3334 1.33333H5.66675C4.26662 1.33333 3.56655 1.33333 3.03177 1.60581C2.56137 1.8455 2.17892 2.22795 1.93923 2.69835C1.66675 3.23313 1.66675 3.9332 1.66675 5.33333V10.6667C1.66675 12.0668 1.66675 12.7669 1.93923 13.3016C2.17892 13.772 2.56137 14.1545 3.03177 14.3942C3.56655 14.6667 4.26662 14.6667 5.66675 14.6667Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.beb0cd9b02f9dc0f623835192c6cab23.svg";
export { ForwardRef as ReactComponent };